module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_IT-b2aa2ff4d3e298c1c5e73c37166a53a0.svg";